import React from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'
import { LANGUAGES } from '../../../../../../utils/constants'
import { flex, tabTitle } from '../../style'
import SelectLanguageCard from './SelectLanguageCard'

interface Props {
    selectedLanguage?: string
    handleLanguage: (language: string) => void
}

const SelectLanguageTab: React.FC<Props> = ({
    selectedLanguage,
    handleLanguage,
}) => {
    const { formatMessage } = useIntl()

    return (
        <Box>
            <Box sx={tabTitle}>{formatMessage({ id: 'chooseLanguage' })}</Box>

            <Box style={flex}>
                {LANGUAGES({ formatMessage }).map((language) => (
                    <SelectLanguageCard
                        key={language.id}
                        languageId={language.id}
                        selected={selectedLanguage === language.id}
                        handleLanguage={handleLanguage}
                    />
                ))}
            </Box>
        </Box>
    )
}

export default SelectLanguageTab
